import request from '@/utils/request'
const api = {
    queryStockCollect(data = {}) {
        let params = ""
        Object.keys(data).forEach((item, index) => {
            if (index === 0) params += "?"
            if (typeof data[item] == "object") {
                params += `${item}=${encodeURI(JSON.stringify(data[item]))}&`
            } else {
                params += `${item}=${data[item]}&`
            }
        })
        return request.post('/mall/demand/userCenter/queryStockCollect' + params, {})
    },
}
export default api